// Vuex connections module main file

import actions from "./actions";
import mutations from "./mutations";

const INITIAL_STATE = {
  plannerList: [],
  plannerListCount: 0,
  calendarEventsList: []
};

const getters = {
  plannerList: state => state.plannerList,
  plannerListCount: state => state.plannerListCount,
  calendarEventsList: state => state.calendarEventsList
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
const Module = {
  namespaced: true,
  state: INITIAL_STATE,
  mutations,
  actions,
  getters
};

export default Module;
